import { chessCamera } from './chessCamera-sidecar'

export function update() {
  // console.log('update?')
  //chessCamera.setZoom(1.5)

  let borderTop = 50
  let borderBottom = borderTop
  let borderLeft = 350
  let borderRight = 50
  let targetHeight = 128 * 8
  let targetWidth = 128 * 8

  let gb = chessCamera.getGameBounds()
  let scale = (gb.height - borderTop - borderBottom) / targetHeight
  let scale2 = (gb.width - borderLeft - borderRight) / targetWidth
  if (scale2 < scale) {
    scale = scale2
  }

  chessCamera.setZoom(scale)
  chessCamera.setCameraXY(-borderLeft, -borderTop)
}
